var _a;
export var CallState;
(function (CallState) {
    CallState[CallState["NotCalled"] = 0] = "NotCalled";
    CallState[CallState["InProcess"] = 1] = "InProcess";
    CallState[CallState["Success"] = 2] = "Success";
    CallState[CallState["Failed"] = 3] = "Failed";
})(CallState || (CallState = {}));
export var TagColors;
(function (TagColors) {
    TagColors["GREEN"] = "green";
    TagColors["GREY"] = "grey";
    TagColors["RED"] = "red";
    TagColors["YELLOW"] = "yellow";
})(TagColors || (TagColors = {}));
export var CardTypeConstants;
(function (CardTypeConstants) {
    CardTypeConstants["Visa"] = "visa";
    CardTypeConstants["Master"] = "master";
    CardTypeConstants["AmericanExpress"] = "american_express";
    CardTypeConstants["DinersClub"] = "diners_club";
    CardTypeConstants["Discover"] = "discover";
    CardTypeConstants["Jcb"] = "jcb";
    CardTypeConstants["Dankort"] = "dankort";
    CardTypeConstants["Maestro"] = "maestro";
})(CardTypeConstants || (CardTypeConstants = {}));
export var CardTypeCollection = (_a = {},
    _a[CardTypeConstants.Visa] = "Visa",
    _a[CardTypeConstants.Master] = "Master",
    _a[CardTypeConstants.AmericanExpress] = "American Express",
    _a[CardTypeConstants.DinersClub] = "Diners Club",
    _a[CardTypeConstants.Discover] = "Discover",
    _a[CardTypeConstants.Jcb] = "Jcb",
    _a[CardTypeConstants.Dankort] = "Dankort",
    _a[CardTypeConstants.Maestro] = "Maestro",
    _a);
export var Currency;
(function (Currency) {
    Currency["CAD"] = "CAD";
    Currency["USD"] = "USD";
    Currency["PEN"] = "PEN";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
    Currency["AUD"] = "AUD";
    Currency["MXN"] = "MXN";
    Currency["NZD"] = "NZD";
    Currency["CNY"] = "CNY";
    Currency["JPY"] = "JPY";
    Currency["INR"] = "INR";
    Currency["COP"] = "COP";
    Currency["CLP"] = "CLP";
})(Currency || (Currency = {}));
export var PassengerTypes;
(function (PassengerTypes) {
    PassengerTypes["Adult"] = "ADT";
    PassengerTypes["InfantInSeat"] = "INS";
    PassengerTypes["InfantInLap"] = "INF";
    PassengerTypes["Child"] = "CNN";
})(PassengerTypes || (PassengerTypes = {}));
export var RegionType;
(function (RegionType) {
    RegionType["Airport"] = "airport";
    RegionType["City"] = "city";
})(RegionType || (RegionType = {}));
export var ModalNames;
(function (ModalNames) {
    ModalNames["HAS_SEEN_ONBOARDING_MODAL"] = "onboarding_modal";
    ModalNames["HAS_SEEN_VXB_ONBOARDING_MODAL"] = "vxb_onboarding_modal";
    ModalNames["SEAN_ELLIS_MODAL"] = "sean_ellis";
    ModalNames["NFU_IN_PRODUCT_AWARENESS_PROFILES"] = "nfu_in_product_awareness_portal_profiles";
    ModalNames["NFU_IN_PRODUCT_AWARENESS_CONFIRMATION"] = "nfu_in_product_awareness_portal_confirmation";
    ModalNames["PACKAGES_EDUCATIONAL_HELPTIP"] = "packages_educational_helptip";
    ModalNames["FREE_FLIGHT_DISRUPTION_ASSISTANCE_TOOLTIP"] = "free_flight_disruption_assistance_tooltip";
    ModalNames["FTB_OFFER_TOOLTIP"] = "ftb_offer_tooltip";
    ModalNames["FB_OFFER_TOOLTIP"] = "fb_offer_tooltip";
    ModalNames["SAME_DAY_ROUND_TRIP_MODAL"] = "single_day_roundtrip_flights_modal";
})(ModalNames || (ModalNames = {}));
export var notSeenModals = {
    sean_ellis: false,
    onboarding_modal: false,
    nfu_in_product_awareness_portal_profiles: false,
    nfu_in_product_awareness_portal_confirmation: false,
    onboarding_checklist: false,
    packages_educational_helptip: false,
    vxb_onboarding_modal: false,
    free_flight_disruption_assistance_tooltip: false,
    ftb_offer_tooltip: false,
    fb_offer_tooltip: false,
    single_day_roundtrip_flights_modal: false,
};
export var Gender;
(function (Gender) {
    Gender["M"] = "M";
    Gender["F"] = "F";
})(Gender || (Gender = {}));
export var Assistance;
(function (Assistance) {
    Assistance["BLND"] = "BLND";
    Assistance["DEAF"] = "DEAF";
    Assistance["STCR"] = "STCR";
    Assistance["WCHR"] = "WCHR";
    Assistance["WCHS"] = "WCHS";
    Assistance["WCHC"] = "WCHC";
    Assistance["WCBD"] = "WCBD";
    Assistance["WCBW"] = "WCBW";
    Assistance["WCLB"] = "WCLB";
    Assistance["WCMP"] = "WCMP";
    Assistance["WCOB"] = "WCOB";
})(Assistance || (Assistance = {}));
export var PassengerTypeEnum;
(function (PassengerTypeEnum) {
    PassengerTypeEnum["Adult"] = "Adult";
    PassengerTypeEnum["Child"] = "Child";
    PassengerTypeEnum["LapInfant"] = "LapInfant";
    PassengerTypeEnum["SeatedInfant"] = "SeatedInfant";
})(PassengerTypeEnum || (PassengerTypeEnum = {}));
export var B2B_PORTAL_JWT_SECRET_KEY = "b2bportal-jwt-secret";
export var B2B_PORTAL_AUTH_REDIRECT_TO = "b2bportal-auth-redirectTo";
export var B2B_PORTAL_AUTH_INVALID_SESSION = "b2bportal-auth-invalid-session";
export var B2B_PORTAL_CSRF_TOKEN = "H-Csrf-Token";
export var B2B_PORTAL_BANNER_CONTAINER_ID = "b2bportal-banner-container";
export var B2B_PORTAL_STARTSESSION_PATH = "/auth/startsession/";
export var B2B_PORTAL_UNAUTHORIZED_PATH = "/auth/invalidsession/";
export var B2B_PORTAL_ENDSESSION_PATH = "/auth/endsession/";
export var BaggageInfoEnum;
(function (BaggageInfoEnum) {
    BaggageInfoEnum["Allowed"] = "Allowed";
    BaggageInfoEnum["NotAllowed"] = "NotAllowed";
    BaggageInfoEnum["Unknown"] = "Unknown";
})(BaggageInfoEnum || (BaggageInfoEnum = {}));
export var PenaltiesInfoEnum;
(function (PenaltiesInfoEnum) {
    PenaltiesInfoEnum["ExternallyManaged"] = "ExternallyManaged";
    PenaltiesInfoEnum["Known"] = "Known";
    PenaltiesInfoEnum["Unknown"] = "Unknown";
})(PenaltiesInfoEnum || (PenaltiesInfoEnum = {}));
export var LocationDescriptorEnum;
(function (LocationDescriptorEnum) {
    LocationDescriptorEnum["BoundingBox"] = "BoundingBox";
    LocationDescriptorEnum["BoundingCircle"] = "BoundingCircle";
})(LocationDescriptorEnum || (LocationDescriptorEnum = {}));
export var LocationQueryEnum;
(function (LocationQueryEnum) {
    LocationQueryEnum["Label"] = "Label";
    LocationQueryEnum["Coordinate"] = "Coordinate";
    LocationQueryEnum["LodgingFeaturedMarkets"] = "LodgingFeaturedMarkets";
    LocationQueryEnum["Empty"] = "Empty";
})(LocationQueryEnum || (LocationQueryEnum = {}));
export var Category;
(function (Category) {
    Category["Airports"] = "Airports";
    Category["Cities"] = "Cities";
    Category["HotelMarkets"] = "HotelMarkets";
    Category["Places"] = "Places";
    Category["RecentSearches"] = "RecentSearches";
    Category["EmptyMatch"] = "EmptyMatch";
    Category["Categories"] = "Categories";
    Category["Experiences"] = "Experiences";
    Category["Attractions"] = "Attractions";
})(Category || (Category = {}));
export var IdEnum;
(function (IdEnum) {
    IdEnum["Flight"] = "Flight";
    IdEnum["HotelMarket"] = "HotelMarket";
    IdEnum["Lodgings"] = "Lodgings";
    IdEnum["Grounds"] = "Grounds";
    IdEnum["Experiences"] = "Experiences";
    IdEnum["Activities"] = "Activities";
})(IdEnum || (IdEnum = {}));
export var ArrowKeyEnum;
(function (ArrowKeyEnum) {
    ArrowKeyEnum["UP"] = "ArrowUp";
    ArrowKeyEnum["DOWN"] = "ArrowDown";
    ArrowKeyEnum["LEFT"] = "ArrowLeft";
    ArrowKeyEnum["RIGHT"] = "ArrowRight";
})(ArrowKeyEnum || (ArrowKeyEnum = {}));
export var ErrorModalType;
(function (ErrorModalType) {
    // hotel error modals
    ErrorModalType["HOTEL_PRICE_DIFFERENCE"] = "hotel-price-difference";
    ErrorModalType["HOTEL_WITH_ADD_ONE_PRICE_DIFFERENCE"] = "hotel-with-add-on-price-difference";
    // other models
    ErrorModalType["FLIGHTS_PRICE_QUOTE_HAS_PRICE_DIFFERENCE"] = "flights-price-quote-has-price-difference";
    ErrorModalType["FLIGHTS_PRICE_QUOTE_WITH_ADD_ON_HAS_PRICE_DIFFERENCE"] = "flights-price-quote-with-add-on-has-price-difference";
    ErrorModalType["FLIGHTS_PRICE_QUOTE_HAS_NO_AVAILABILITY"] = "flights-price-quote-has-no-availability";
    ErrorModalType["FLIGHT_INACTIVITY"] = "flights-inactivity";
    ErrorModalType["PROVIDER_ERROR"] = "provider-error";
    ErrorModalType["NO_ADULT_PASSENGER"] = "no-adult-passenger";
    ErrorModalType["DUPLICATE_BOOKING"] = "duplicate-booking";
})(ErrorModalType || (ErrorModalType = {}));
export var CloseButtonActionEnum;
(function (CloseButtonActionEnum) {
    CloseButtonActionEnum[CloseButtonActionEnum["HoteLoyaltyClose"] = 0] = "HoteLoyaltyClose";
})(CloseButtonActionEnum || (CloseButtonActionEnum = {}));
export var ErrorType;
(function (ErrorType) {
    ErrorType["BookError"] = "BookError";
    ErrorType["BookFailed"] = "BookFailed";
    ErrorType["CannotResume"] = "CannotResume";
    ErrorType["CaptureFailed"] = "CaptureFailed";
    ErrorType["CardDeclined"] = "CardDeclined";
    ErrorType["CheckInMinAgeNotMet"] = "CheckInMinimumAgeNotMet";
    ErrorType["DuplicateBooking"] = "DuplicateBooking";
    ErrorType["ExecutionTimeout"] = "ExecutionTimeout";
    ErrorType["FlightPaymentError"] = "FlightPaymentError";
    ErrorType["HardTimeout"] = "HardTimeout";
    ErrorType["Inactivity"] = "Inactivity";
    ErrorType["Incomplete"] = "Incomplete";
    ErrorType["InvalidGDSCharacter"] = "InvalidGDSCharacter";
    ErrorType["InvalidOffPoint"] = "InvalidOffPoint";
    ErrorType["InvalidPassengers"] = "InvalidPassengers";
    ErrorType["InvalidRequestError"] = "InvalidRequestError";
    ErrorType["InvalidScheduleChangeUA"] = "InvalidScheduleChangeUserAction";
    ErrorType["InvalidSegmentStatus"] = "InvalidSegmentStatus";
    ErrorType["MaxPriceIncreaseReached"] = "MaximumPriceIncreaseReached";
    ErrorType["MissingAirlineLocator"] = "MissingAirlineLocator";
    ErrorType["NoAvailability"] = "NoAvailability";
    ErrorType["NoProductsAvailable"] = "NoProductsAvailable";
    ErrorType["NoTicketlessResponse"] = "NoTicketlessResponse";
    ErrorType["NotApplicable"] = "N/A";
    ErrorType["NotTicketed"] = "NotTicketed";
    ErrorType["ParseError"] = "ParseError";
    ErrorType["PaymentError"] = "PaymentError";
    ErrorType["PrinterProfileAlreadyDesignated"] = "PrinterProfileAlreadyDesignated";
    ErrorType["ProviderError"] = "ProviderError";
    ErrorType["RMStepTimeout"] = "RemoteMachineStepTimeout";
    ErrorType["RMUncaughtException"] = "RemoteMachineUncaughtException";
    ErrorType["ReadRatesError"] = "ReadRatesError";
    ErrorType["RedemptionFailure"] = "RedemptionFailure";
    ErrorType["RequirementUnsupported"] = "RequirementUnsupported";
    ErrorType["SchedulingError"] = "SchedulingError";
    ErrorType["SegmentCancelledAfterTicketing"] = "SegmentCanceledAfterTicketing";
    ErrorType["SessionClosed"] = "SessionClosed";
    ErrorType["TicketReadError"] = "TicketReadError";
    ErrorType["Timeout"] = "Timeout";
    ErrorType["TipFetchFailed"] = "TipFetchFailed";
    ErrorType["TransientServiceError"] = "TransientServerError";
    ErrorType["UncategorizedError"] = "UncategorizedError";
    ErrorType["UncaughtException"] = "UncaughtException";
    ErrorType["UnconfirmedStatus"] = "UnconfirmedStatus";
    ErrorType["UnknownSabreAppError"] = "UnknownSabreAppError";
    ErrorType["VoidFailed"] = "VoidFailed";
    ErrorType["ZenDeskUserException"] = "ZenDeskUserException";
})(ErrorType || (ErrorType = {}));
export var FlightShopStep;
(function (FlightShopStep) {
    FlightShopStep[FlightShopStep["PricePrediction"] = 0] = "PricePrediction";
    FlightShopStep[FlightShopStep["ChooseDeparture"] = 1] = "ChooseDeparture";
    FlightShopStep[FlightShopStep["ChooseReturn"] = 2] = "ChooseReturn";
    FlightShopStep[FlightShopStep["ReviewItinerary"] = 3] = "ReviewItinerary";
    FlightShopStep[FlightShopStep["FareDetails"] = 4] = "FareDetails";
})(FlightShopStep || (FlightShopStep = {}));
export var CustomEvents;
(function (CustomEvents) {
    CustomEvents["editTravelersStateChange"] = "EditTravelersStateChange";
    CustomEvents["showSupportModal"] = "ShowSupportModal";
})(CustomEvents || (CustomEvents = {}));
export var EditTravelerModalState;
(function (EditTravelerModalState) {
    EditTravelerModalState[EditTravelerModalState["closed"] = 1] = "closed";
    EditTravelerModalState[EditTravelerModalState["flight"] = 2] = "flight";
    EditTravelerModalState[EditTravelerModalState["ground"] = 3] = "ground";
    EditTravelerModalState[EditTravelerModalState["hotel"] = 4] = "hotel";
    EditTravelerModalState[EditTravelerModalState["stays"] = 5] = "stays";
    EditTravelerModalState[EditTravelerModalState["trips"] = 6] = "trips";
    EditTravelerModalState[EditTravelerModalState["experiences"] = 7] = "experiences";
    EditTravelerModalState[EditTravelerModalState["wallet"] = 8] = "wallet";
    EditTravelerModalState[EditTravelerModalState["packages"] = 9] = "packages";
})(EditTravelerModalState || (EditTravelerModalState = {}));
export var TravelerType;
(function (TravelerType) {
    TravelerType["email"] = "email";
    TravelerType["phoneNumber"] = "phoneNumber";
})(TravelerType || (TravelerType = {}));
export var TravelerTypeEdit;
(function (TravelerTypeEdit) {
    TravelerTypeEdit["email"] = "Email";
    TravelerTypeEdit["phone"] = "Phone";
})(TravelerTypeEdit || (TravelerTypeEdit = {}));
export var MediaAssetKindEnum;
(function (MediaAssetKindEnum) {
    MediaAssetKindEnum["Unspecified"] = "Unspecified";
    MediaAssetKindEnum["Image"] = "Image";
})(MediaAssetKindEnum || (MediaAssetKindEnum = {}));
export var MediaAssetTagEnum;
(function (MediaAssetTagEnum) {
    MediaAssetTagEnum["Bathroom"] = "Bathroom";
    MediaAssetTagEnum["LivingArea"] = "LivingArea";
    MediaAssetTagEnum["Kitchen"] = "Kitchen";
    MediaAssetTagEnum["DiningArea"] = "DiningArea";
    MediaAssetTagEnum["Bedroom"] = "Bedroom";
    MediaAssetTagEnum["Exterior"] = "Exterior";
    MediaAssetTagEnum["Unknown"] = "Unknown";
})(MediaAssetTagEnum || (MediaAssetTagEnum = {}));
export var getSubtitleTrackingValue = function (errorTitles) {
    var subtitle = errorTitles.subtitle;
    if (!subtitle) {
        return "";
    }
    if (typeof subtitle === "string") {
        return subtitle;
    }
    return String(subtitle.props.children);
};
//# sourceMappingURL=interfaces.js.map